import { Action, ActionType } from "@redux/actionTypes/excipientPmActionTypes";
import { Reducer } from "redux";

export interface IExipientPMState {
  excpDetailsByPID: IExcpPmDetailsByPID[];
}

export interface IExcpPmDetailsByPID {
  projectId: number;
  projectName: string;
  dosageForms: string;
  headers: Iheaders[];
  tableData: Record<string, any>[];
  calculations?: ICalculation;
}
export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
}
export interface ICalculation {
  header: Iheaders[];
  exhibiTable: Record<string, any>[];
  prototypeTable: Record<string, any>[];
  scaleUpTable: Record<string, any>[];
}

const initialState = {
  excpDetailsByPID: [],
};

export const excpPmReducer: Reducer<IExipientPMState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.EXCIPIENT_PM_DETAILS_BY_PID:
      return {
        ...state,
        excpDetailsByPID: action.payload,
      };
    default:
      return state;
  }
};
